import Vue from "vue";
import CardBody from "./CardBody.vue";
export default Vue.extend({
    name: "Card",
    components: {
        CardBody,
    },
    props: {
        noBody: {
            type: Boolean,
            default: false,
        },
        tight: {
            type: Boolean,
            default: false,
        },
        low: {
            type: Boolean,
            default: false,
        },
        variant: {
            type: String,
            validator: (v) => ["default", "info", "warning", "error"].includes(v),
            default: "default",
        },
        noShadow: {
            type: Boolean,
            default: false,
        },
        accordion: {
            type: Boolean,
            default: false,
        },
        bordered: {
            type: Boolean,
            default: false,
        },
        rounded: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        cardClasses() {
            return {
                "c-card": true,
                "c-card--low": this.low,
                "c-card--rounded": this.rounded,
                "c-card--no-shadow": this.noShadow,
                "c-card--accordion": this.accordion,
                "c-card--info": this.variant === "info",
                "c-card--warning": this.variant === "warning",
                "c-card--error": this.variant === "error",
                "c-card--bordered": this.bordered,
            };
        },
    },
});
